import { CircularProgress } from "@material-ui/core";
import React from "react";
import store from "src/store";
import { Input } from "./input";
import ParameterDisplay from "./parameter-display";
import ValueOrChoose from "./value-or-choose";
import { useStepIndex } from "./step-index-context";

export default function ExpectedOutputDeclare(props) {
    var stepIndex=useStepIndex()
    let step = store.steps[stepIndex];
    let previousSteps = store.steps.filter((s, index) => index < stepIndex);

    let thisFunctionABI = props.getThisFunctionABI();

    const changeInput = (index, e) => {
        store.removeResults(stepIndex);
        store.steps[stepIndex]['expected_output'] = store.steps[stepIndex]['expected_output'] || []
        let v = e.target ? e.target.value : e;
        if (typeof (v) != 'boolean') {
            if (v) {
                store.steps[stepIndex]['expected_output'][index] = v;
            } else {
                store.steps[stepIndex]['expected_output'].splice(index, 1);
            }
        } else {
            store.steps[stepIndex]['expected_output'][index] = v;
        }
        store.updateStore()
    }

    if(store.steps[stepIndex].type=='CHECk_BALANCE') {
      return <>
      <div css="
      margin-top: 10px"
      >
  
        <div css={`
        margin-top: 1-px;
        `}>
                <ValueOrChoose
                    //@ts-ignore
                    width="100%"
                    disabled={store.isStepReadOnly(stepIndex)}
                    skipSelector
                    wrapperWidth="100%"
                    grow={1}
                    label={
                        "Expected Output" 
                    }
                    labelBackground="white"
                    value={store.steps[stepIndex]['expected_output']?.[0]|| ""}
                    onChange={e=>{
                      store.removeResults(stepIndex)
                      store.steps[stepIndex]['expected_output']=[e];
                      store.updateStore()}}
                    type="ether"
                    onChoose={() => { }}
                />
            </div>
        </div>
        </>
    }
    return (
        <>
            <div css="
            margin-top: 20px"
            >
                {
                    (((thisFunctionABI?.outputs?.length > 0 && step.abiLoadingStatus == "ready") || step.abiLoadingStatus == "loading")) &&
                    (
                        <>
                            <Input
                                width="100%"
                                wrapperWidth="100%"
                                label={'Expected output'}
                            >
                                <div>
                                    {step.abiLoadingStatus == "loading" &&
                                        <div css={`
                                    margin: 15px;
                                    `}>
                                            <CircularProgress
                                                size={12}
                                            />
                                        </div>
                                    }

                                    {step.abiLoadingStatus == "ready" && thisFunctionABI?.outputs?.map((output, index) => (
                                        <div key={index} css={`
                                    margin: 15px;
                                    `}>
                                            <ValueOrChoose
                                                //@ts-ignore
                                                width="100%"
                                                disabled={store.isStepReadOnly(stepIndex)}
                                                skipSelector
                                                wrapperWidth="100%"
                                                chooseValue=""
                                                label={
                                                    output.name ? output.name : "Output value #" + (index + 1)
                                                }
                                                value={(store.steps[stepIndex]['expected_output'] && store.steps[stepIndex]['expected_output'][index]) || ""}
                                                onChange={changeInput?.bind(null, index)}
                                                type={output.type}
                                                onChoose={() => { }}
                                                list={
                                                    output.type == "address"
                                                        ? //@ts-ignore
                                                        previousSteps
                                                            .filter(s => s.deployAlias)
                                                            .map(x => x.deployAlias)
                                                        : []
                                                }
                                            />
                                        </div>
                                    ))}
                                </div>
                            </Input>
                        </>
                    )}
            </div>
        </>
    )
}